<template>
  <v-container fluid class="docForm">
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Sale Return / Credit Note</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <div>

          <v-row>
          
          <!-- datepicker 2 -->
          <v-col cols="12" xs="12" md="3">
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  dense
                  outlined
                  single-line
                  v-model="record.StartDate"
                  label="From"
                  prepend-icon="mdi-calendar-month"
                  v-on="on"
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker v-model="record.StartDate" @input="menu1 = false"></v-date-picker>
            </v-menu>
          </v-col>

          <!-- datepicker 2 -->
          <v-col cols="12" xs="12" md="3">
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  dense
                  outlined
                  single-line
                  v-model="record.EndDate"
                  label="To"
                  prepend-icon="mdi-calendar-month"
                  v-on="on"
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker v-model="record.EndDate" @input="menu2 = false"></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" xs="12" md="3">
            <v-autocomplete
              autocomplete="off"
              dense
              outlined
              v-model="record.CustomerId"
              :items="customers"
              label="Customer"
              item-text="Name"
              item-value="id"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" xs="12" md="3">
            <v-btn
              class="right"
              color="primary"
              :loading="loader"
              @click="queryInvoices"
            >Query Invoices</v-btn>
          </v-col>
        </v-row>

          <v-row dense>
            <v-col cols="12">
              <v-text-field dense label="Search" v-model="search"></v-text-field>
            </v-col>

            <v-divider></v-divider>
          </v-row>

          <v-row class="subtitle-2 text--primary">
            <v-col cols="12">
              <v-data-table
              :mobile-breakpoint="0"
              :items-per-page="pageItems"
              :headers="headers"
              :items="returns"
              :search="search"
            >
              <!-- template -->
              <template v-slot:item.DocTotal="{ item }">{{ item.DocTotal | currency }}</template>
              <!-- end -->
            
              <!-- template -->
              <template v-slot:item.Date="{ item }">
                {{
                item.Date | date
                }}
              </template>
              <!-- end -->

              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn color="accent" text :to="`/sale-return-details/${item.id}`">
                 More Details
                  <v-icon right>mdi-eye</v-icon>
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
  
              <!-- snackbar -->
              <snackbar ref="snackbar"></snackbar>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </v-card>

    <!-- start of default dialog -->
    <v-dialog
      v-model="invoicesDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar color="secondary" flat dense>
          <v-toolbar-title>
            <v-btn icon @click="invoicesDialog = false">
              <v-icon>mdi-keyboard-backspace</v-icon>
            </v-btn>Sales Return / Credit Note
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="invoicesDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-row justify="center" class="mt-3">
            <v-col cols="10">
              <v-row class="mt-2">
                <v-col cols="12">
                  <v-text-field dense label="Search" v-model="searchInvoices"></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-data-table
                    :mobile-breakpoint="0"
                    :items-per-page="pageItems"
                    :headers="headers"
                    :items="dailySales"
                    :search="searchInvoices"
                  >
                    <!-- template -->
                    <template v-slot:item.DocTotal="{ item }">{{ item.DocTotal | currency }}</template>
                    <!-- end -->
                    <!-- template -->
                    <template v-slot:item.TotalPaid="{ item }">
                      {{
                      item.TotalPaid | currency
                      }}
                    </template>
                    <!-- end -->
                    <!-- template -->
                    <template v-slot:item.Balance="{ item }">
                      {{
                      item.Balance | currency
                      }}
                    </template>
                    <!-- end -->

                    <!-- template -->
                    <template v-slot:item.Date="{ item }">
                      {{
                      item.Date | date
                      }}
                    </template>
                    <!-- end -->

                    <!-- action template -->
                    <template v-slot:item.action="{ item }">
                      <v-btn color="accent" text :to="`/credit-notes/${item.id}`">
                        <v-icon left>mdi-clipboard-arrow-left</v-icon>Return Sold Items
                      </v-btn>
                    </template>
                    <!-- end -->
                  </v-data-table>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of default dialog -->
  </v-container>
</template>

<script>
import "export-json-excel";
export default {
  computed: {
    storeName() {
      return localStorage.getItem("storeName");
    },
    role() {
      return localStorage.getItem("userRole");
    }
  },
  data() {
    return {
      record: {},
      invoicesDialog: false,
      productsDialog: false,
      salesLoader: false,
      soldItems: [],
      pageItems: 100,
      zeroValue: 0,
      menu1: false,
      menu2: false,
      loader: false,
      search: null,
      searchInvoices: "",
      customers: [],
      reportData: {},
      TotalReturns: null,
      TotalServices: 0,
      returnsData: [],
      reportDataAllSales: [],
      cancelledDialog: false,
      cancelledData: [],
      drivers: [],
      dailySales: [],
      returns: [],
      totalReturns: 0,
      date: new Date().toISOString().substr(0, 10),
      headers: [
        { text: "Doc Num.", value: "DocNum", sortable: false },
        { text: "Customer", value: "CustomerName", sortable: false },
        { text: "Total", value: "DocTotal", sortable: false },
        { text: "Date", value: "Date", sortable: false },
        { text: "Action", value: "action", sortable: false }
      ]
    };
  },
  methods: {
    setStartDate(date) {
      this.record.StartDate = date;
    },
    setEndDate(date) {
      this.record.EndDate = date;
    },
    queryInvoices() {
     let data = {
        StartDate: this.record.StartDate,
        EndDate: this.record.EndDate,
        CustomerId: 0
      };

      const self = this;
      const url = `/daily-sales-report`;
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.dailySales = res.ResponseData.sales;
            self.invoicesDialog = true;
            self.loader = false;
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
            self.loader = false;
          }
        })
        .catch(err => {
          self.loader = false;
          this.$refs.snackbar.show(err, "red");
        });
    },
    getReport() {
     let data = {
        StartDate: this.date,
        EndDate: this.date,
        CustomerId: 0
      };

      const self = this;
      const url = `/sale-returns-report`;
      this.$store.commit("loader", true);
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.returns = res.ResponseData.returns;
            self.totalReturns = res.ResponseData.totalReturns;
            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
            self.$store.commit("loader", false);
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getCustomers() {
      const self = this;
      this.$store
        .dispatch("get", `/customers`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.customers = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    exportToExcel() {}
  },
  created() {
    this.getCustomers();
    this.getReport();
  }
};
</script>

<style lang="scss" scoped>
</style>